import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import T from 'src/utils/T';

const propTypes = {
  open: PropTypes.bool.isRequired,
  onApprove: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export const LogoutPopup = ({
  open,

  onApprove,
  onReject,
}) => (
  <Dialog open={open} onClose={onReject} data-testid="LogoutPopup">
    <DialogTitle disableTypography>
      <Typography variant="h5">
        <T t="appbar.popupLogout.title" />
      </Typography>
    </DialogTitle>

    <DialogContent>
      <Typography variant="body1">
        <T t="appbar.popupLogout.content" />
      </Typography>
    </DialogContent>

    <DialogActions>
      <Button
        onClick={onReject}
        aria-label="Reject"
        data-testid="LogoutPopup__RejectButton"
      >
        <T t="appbar.popupLogout.reject" />
      </Button>

      <Button
        onClick={onApprove}
        variant="contained"
        color="primary"
        autoFocus
        aria-label="Approve"
        data-testid="LogoutPopup__ApproveButton"
      >
        <T t="appbar.popupLogout.approve" />
      </Button>
    </DialogActions>
  </Dialog>
);

LogoutPopup.propTypes = propTypes;
